import RegistrationScreen from './registration';
import SigninScreen from './signin';

const routes = [
  {
    path: '/signin',
    component: SigninScreen,
  },
  {
    path: '/registration',
    component: RegistrationScreen,
  },
];

export default routes;
